import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import EmployeeFormContainer from './EmployeeFormContainer';


const EmployeeAddContainer = () => {
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState({ name: '사원 신규 추가' });
  const handleGoBack = () => {
    navigate('/employeemng');
  };
  return (
    <>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="인사 관리/시원 관리/추가"
        menuLink="/employeemng"
        icon="user"
        titleData={titleData}
      />
      <EmployeeFormContainer type="add" />
    </>
  );
};

export default EmployeeAddContainer;
